import './About.scss'
import React from 'react'

import portrait from '../../assets/portrait_ben_gibert.webp'

function About() {
    return (
        <section
            id="a-propos"
            className="about"
            aria-labelledby="about-title"
        >
            <div className="about__container">
                <div className="about__text">
                    <p className="about__eyebrow">À propos</p>

                    <h2 id="about-title" className="about__title">
                        Qui je suis
                    </h2>

                    <p className="about__paragraph">
                        Benjamin Gibert, développeur et architecte technique
                        web à Toulouse.
                    </p>

                    <p className="about__paragraph">
                        J’interviens en direct avec vous, du diagnostic à la
                        mise en ligne, pour que votre site et vos outils
                        restent simples à faire évoluer.
                    </p>
                </div>

                <figure className="about__figure">
                    <img
                        className="about__image"
                        src={portrait}
                        alt="Portrait de Benjamin Gibert"
                        width="1328"
                        height="800"
                        loading="lazy"
                    />
                </figure>
            </div>
        </section>
    )
}

export default About
